import React from 'react'
import { IconName } from '@fortawesome/fontawesome-svg-core'
import { UploadProduct } from '../../helpers/orderUploads'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

interface UploadProductListProps {
    products: UploadProduct[]
    selectedProductId?: number
    onSelect(productId: number): void
}

const UploadProductList: React.FC<UploadProductListProps> = ({ products, selectedProductId, onSelect }) => (
    <div className='w-full lg:w-1/3 flex flex-col border-r'>
        {products.map((product) => (
            <button
                key={product.id}
                type='button'
                onClick={() => onSelect(product.id)}
                className={`flex items-center gap-3 px-4 py-4 text-left border-b hover:bg-gray-50 ${product.id === selectedProductId ? 'bg-[--tb-blushPrimary] text-[--tb-primary]' : ''}`}
            >
                <DynamicFaIcon iconName={(product.icon || 'box') as IconName} />
                <span className='font-medium'>{product.name}</span>
            </button>
        ))}
    </div>
)

export default UploadProductList
